import SubscriptionCard from './SubscriptionCard.component';

export default SubscriptionCard;
